import React from 'react';
import { classes, st } from '../../AgendaItem.st.css';
import {
  Avatar,
  AvatarSize,
  Button,
  ButtonSize,
  Text,
  ThumbnailImage,
} from 'wix-ui-tpa/cssVars';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { AgendaItemLayoutProps } from '../const';

export const AgendaItemListLayout: React.FC<AgendaItemLayoutProps> = ({
  agendaItemViewModel,
  onSlotClick,
}) => {
  const {
    serviceName,
    serviceImage,
    startTime,
    duration,
    staffName,
    staffImage,
    location,
    spots,
    price,
    buttonText,
    disabled,
    slotId,
  } = agendaItemViewModel || {};
  const { isMobile } = useEnvironment();

  return (
    <>
      <ThumbnailImage {...serviceImage} className={classes.serviceImage} />

      <div className={st(classes.content, classes.colWrapper)}>
        <div className={st(classes.colWrapper, classes.col, classes.col3)}>
          <div className={st(classes.col1Wrapper, classes.col)}>
            <Text className={classes.serviceName}>{serviceName}</Text>
            <div className={classes.col2}>
              <Text className={classes.startTime}>
                {startTime}{' '}
                <Text className={classes.duration}>({duration})</Text>
              </Text>
            </div>
          </div>
          <div
            className={st(
              classes.col2Wrapper,
              classes.col,
              classes.staffAndLocationWrapper,
            )}
          >
            <div className={classes.staff}>
              <Avatar
                className={classes.staffImage}
                size={AvatarSize.small}
                src={staffImage}
                name={staffName}
              />
              <Text className={classes.staffName}>{`${staffName} ${
                location && isMobile ? '•' : ''
              }`}</Text>
            </div>
            <Text className={classes.location}>{location}</Text>
          </div>
        </div>
        <div className={st(classes.colWrapper, classes.col, classes.colNoWrap)}>
          <div className={st(classes.col2Wrapper, classes.col)}>
            <Text className={classes.price}>{price}</Text>
            <Text className={classes.spots}>{spots}</Text>
          </div>
          <div className={st(classes.col, classes.buttonWrapper)}>
            <Button
              onClick={() => onSlotClick(slotId)}
              disabled={disabled}
              className={classes.button}
              size={ButtonSize.tiny}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
